<div class="preloader" *ngIf="isLoading">
    <img style="height: 70px" class="preloader__image" width="60" src="assets/images/loader.png" alt="img" />
</div>
